/**
 * Finch: load optional heavy libs when needed; idle-load non-critical scripts;
 * delay Facebook Pixel until user interaction (avoids legacy JS on first paint);
 * autoplay below-fold videos when in view.
 * Configured via window.finchPerfAssets from finch-theme-scripts.liquid.
 */
(function () {
	function getAssets() {
		return window.finchPerfAssets || {};
	}

	var loaded = {};

	function loadScript(src) {
		if (!src || loaded[src]) return loaded[src] || Promise.resolve();
		loaded[src] = new Promise(function (resolve, reject) {
			if (document.querySelector('script[data-finch-src="' + src + '"]')) {
				resolve();
				return;
			}
			var script = document.createElement('script');
			script.src = src;
			script.defer = true;
			script.dataset.finchSrc = src;
			script.onload = resolve;
			script.onerror = reject;
			document.head.appendChild(script);
		});
		return loaded[src];
	}

	function whenIdle(fn) {
		if (typeof window.requestIdleCallback === 'function') {
			window.requestIdleCallback(fn, { timeout: 4000 });
		} else {
			window.addEventListener('load', function () {
				setTimeout(fn, 1);
			});
		}
	}

	function onFirstInteraction(fn) {
		var fired = false;
		function run() {
			if (fired) return;
			fired = true;
			events.forEach(function (evt) {
				window.removeEventListener(evt, run, true);
			});
			fn();
		}
		var events = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
		events.forEach(function (evt) {
			window.addEventListener(evt, run, { once: true, passive: true, capture: true });
		});
	}

	function needsParallax() {
		return Boolean(
			document.querySelector(
				'[data-parallax], .parallax-gallery, .tsi__parallax, .split-screen-slideshow'
			)
		);
	}

	function needsMarquee() {
		return Boolean(document.querySelector('.marquee, [data-ticker-id]'));
	}

	function loadParallaxStack() {
		var assets = getAssets();
		var chain = Promise.resolve();
		if (assets.observer)
			chain = chain.then(function () {
				return loadScript(assets.observer);
			});
		if (assets.scrollTrigger)
			chain = chain.then(function () {
				return loadScript(assets.scrollTrigger);
			});
		if (assets.parallax)
			chain = chain.then(function () {
				return loadScript(assets.parallax);
			});
		return chain;
	}

	function loadIdleThemeScripts() {
		var idle = getAssets().idle || {};
		var tasks = [];
		if (idle.popup) tasks.push(loadScript(idle.popup));
		if (idle.scrollTop) tasks.push(loadScript(idle.scrollTop));
		return Promise.all(tasks);
	}

	function loadFacebookPixel() {
		var idle = getAssets().idle || {};
		if (idle.facebook) return loadScript(idle.facebook);
		return Promise.resolve();
	}

	function setupLazyVideos() {
		var videos = document.querySelectorAll('video[data-finch-lazy-video]');
		if (!videos.length) return;

		function playVideo(video) {
			video.muted = true;
			video.setAttribute('playsinline', '');
			var playPromise = video.play();
			if (playPromise && typeof playPromise.catch === 'function') {
				playPromise.catch(function () {});
			}
		}

		if (!('IntersectionObserver' in window)) {
			videos.forEach(playVideo);
			return;
		}

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (!entry.isIntersecting) return;
					playVideo(entry.target);
					observer.unobserve(entry.target);
				});
			},
			{ rootMargin: '200px 0px' }
		);

		videos.forEach(function (video) {
			observer.observe(video);
		});
	}

	function run() {
		var assets = getAssets();
		var tasks = [];
		if (needsParallax()) tasks.push(loadParallaxStack());
		if (needsMarquee() && assets.marquee) tasks.push(loadScript(assets.marquee));
		setupLazyVideos();
		return Promise.all(tasks);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', run);
	} else {
		run();
	}

	whenIdle(loadIdleThemeScripts);
	onFirstInteraction(loadFacebookPixel);

	document.addEventListener('shopify:section:load', function () {
		run();
		loadIdleThemeScripts();
	});
})();
